import { LibraryTemplate, MetaProduct } from "src/server/zsl/templates/types";

export type Product = MetaProduct;
export const products: Product[] = [
  "canvas",
  "chatbot",
  "interfaces",
  "tables",
  "zaps",
] as const;

export const capitalizedProductStrings: Record<Product, string> = {
  canvas: "Canvas",
  chatbot: "Chatbots",
  interfaces: "Interfaces",
  tables: "Tables",
  zaps: "Zaps",
};

export const capitalizedProductStringsSingular: Record<Product, string> = {
  canvas: "Canvas",
  chatbot: "Chatbot",
  interfaces: "Interface",
  tables: "Table",
  zaps: "Zap",
};

export const convertSlugToProduct = (slug: string): Product | null => {
  return slug && products.includes(slug as Product) ? (slug as Product) : null;
};

export const isProductRelevant = (
  template: LibraryTemplate,
  product: Product,
): boolean => {
  if (!template.meta.primaryProduct) return false;
  return product.includes(template.meta.primaryProduct);
};

export const filterOnlyProductRelevantTemplates = ({
  templates,
  product,
  limit,
}: {
  product: Product;
  templates?: LibraryTemplate[];
  limit?: number;
}): LibraryTemplate[] => {
  const allFiltered =
    templates?.filter((t) => isProductRelevant(t, product)) ?? [];
  if (limit === undefined) return allFiltered;
  return allFiltered.slice(0, limit);
};
